import Vue from 'vue'
import Router from 'vue-router'
import Privacy from "../components/Privacy.vue";
import UserAgreement from '../components/UserAgreement';
import ThirdPartySharingList from '../components/ThirdPartySharingList';
import CMCCTerms from '../components/CMCCTerms';
import NoDevice from '../components/NoDevice';
import ProductInstructions from '../components/ProductInstructions';
import MaintenanceInstructions from '../components/MaintenanceInstructions';
import NoReaction from '../components/NoReaction';
import CannotFindDevice from '../components/CannotFindDevice';
import ConnectionFailedFirmwareVersion from '../components/ConnectionFailedFirmwareVersion';
import FAQ from "../components/FAQ.vue";
import PrivacySummary from '../components/PrivacySummary.vue';
import YouthProtection from '../components/YouthProtection.vue';
import DeleteAccount from '../components/DeleteAccount.vue';
import DontSell from '../components/DontSell.vue';

// 语言映射表
const languageMap = {
  'zh-CN': 'zh-CN',
  'zh': 'zh-CN',  // 兼容 'zh'，默认用简体中文
  'en': 'en',
  'fr': 'fr',
  'de': 'de',
  'es': 'es'
};

// 页面标题国际化
const pageTitles = {
  'Privacy': {
    'zh-CN': '隐私保护协议',
    'en': 'Privacy Policy'
  },
  'DontSell': {
    'zh-CN': 'Do Not Sell My Personal Information',
    'en': 'Do Not Sell My Personal Information'
  },
  'PrivacySummary': {
    'zh-CN': '神奇睡眠隐私政策摘要',
    'en': 'One2Sleep Privacy Policy Summary'
  },
  'UserAgreement': {
    'zh-CN': '用户协议',
    'en': 'User Agreement'
  },
  'YouthProtection': {
    'zh-CN': '青少年个人信息保护协议',
    'en': 'Youth Personal Information Protection Agreement'
  },
  'ThirdPartySharingList': {
    'zh-CN': '第三方共享清单',
    'en': 'Third-Party Sharing List'
  },
  'CMCCTerms': {
    'zh-CN': '中国移动服务条款',
    'en': 'China Mobile Service Terms'
  },
  'DeleteAccount': {
    'zh-CN': '删除账号',
    'en': 'Delete Account'
  },
  'NoDevice': {
    'zh-CN': '没有设备，随便逛逛',
    'en': 'No Device, Just Browsing'
  },
  'ProductInstructions': {
    'zh-CN': '产品使用说明书',
    'en': 'Product Instructions'
  },
  'MaintenanceInstructions': {
    'zh-CN': '产品日常保养说明',
    'en': 'Maintenance Instructions'
  },
  'FAQ': {
    'zh-CN': '常见问题解答',
    'en': 'FAQ'
  },
  'NoReaction': {
    'zh-CN': '连接充电器后设备仍无反应',
    'en': 'Device Still Not Responding After Connecting Charger'
  },
  'CannotFindDevice': {
    'zh-CN': '无法找到我的设备，查看帮助',
    'en': 'Cannot Find My Device, View Help'
  },
  'ConnectionFailedFirmwareVersion': {
    'zh-CN': '连接失败（由于固件的协议版本号过高）',
    'en': 'Connection Failed (Due to High Firmware Protocol Version)'
  }
};

// 获取当前语言
const getCurrentLanguage = () => {
  let urlLang = null;
  const hash = window.location.hash || '';
  const langMatchFromHash = hash.match(/[?&]lang=([a-zA-Z-]+)/);
  if (langMatchFromHash && langMatchFromHash[1]) {
    urlLang = langMatchFromHash[1];
  }
  
  let langMatch = null;
  if (navigator.userAgent) {
    const match = navigator.userAgent.match(/AppLang\/([a-z]{2}(?:-[A-Z]{2})?)/);
    if (match && match[1]) {
      langMatch = match[1];
    }
  }
  
  const userLang = urlLang || langMatch || navigator.language || 'zh-CN';
  return languageMap[userLang] || 'zh-CN';
};

// 动态加载组件的函数
const getComponentByLang = (componentName) => {
  // 1. 处理 hash 模式下的 URL 参数
  let urlLang = null;
  const hash = window.location.hash || '';
  const langMatchFromHash = hash.match(/[?&]lang=([a-zA-Z-]+)/);
  if (langMatchFromHash && langMatchFromHash[1]) {
    urlLang = langMatchFromHash[1];
    console.log('Lang from hash:', urlLang);
  }
  console.log(navigator.userAgent)
  let langMatch = null
  if (navigator.userAgent ){
    const match = navigator.userAgent.match(/AppLang\/([a-z]{2}(?:-[A-Z]{2})?)/);
    if (match && match[1]){
      langMatch = match[1]
    }
    console.log(langMatch)
  }
  const userLang = urlLang || langMatch || navigator.language || 'zh-CN';  // 获取浏览器的语言，默认使用 'zh-CN'，优先级：路径携带 > userAgent > 浏览器语言

  // 从浏览器语言获取对应的语言代码
  const langCode = languageMap[userLang] || 'zh-CN';  // 默认使用 'zh-CN'

  // 检查是否为 overseas 环境
  const buildEnv = process.env.BUILD_ENV || '';
  const isOverseas = buildEnv.includes('overseas');
  
  // 如果是 UserAgreement 或 Privacy 且在 overseas 环境，加载对应的 Overseas 版本
  let finalComponentName = componentName;
  if (isOverseas) {
    if (componentName === 'UserAgreement') {
      finalComponentName = 'UserAgreementOverseas';
    } else if (componentName === 'Privacy') {
      finalComponentName = 'PrivacyOverseas';
    }
  }

  try {
    console.log('langCode', langCode, 'componentName', finalComponentName, 'isOverseas', isOverseas)
    // 动态加载组件，使用 import 语法
    return import(`../components/${langCode}/${finalComponentName}.vue`);
  } catch (error) {
    console.error(`Component ${componentFileName} not found, falling back to default language`);
    // 默认返回英文版组件
    return import(`../components/en/${finalComponentName}.vue`);
  }
};


Vue.use(Router)

const router = new Router({
  routes: [
    // { path: '/policy/privacy', name: 'Privacy', component: Privacy, meta: { title: '隐私保护协议' }},
    // { path: '/policy/user-agreement', name: 'UserAgreement', component: UserAgreement, meta: { title: '用户协议' }},
    // { path: '/policy/third-party-sharing', name: 'ThirdPartySharingList', component: ThirdPartySharingList },
    // { path: '/policy/CMCC-terms', name: 'CMCCTerms', component: CMCCTerms },
    // { path: '/support/no-device', name: 'NoDevice', component: NoDevice },
    // { path: '/docs/product-instructions', name: 'ProductInstructions', component: ProductInstructions },
    // { path: '/docs/maintenance-instructions', name: 'MaintenanceInstructions', component: MaintenanceInstructions },
    // { path: '/guide/FAQ', name: 'FAQ', component: FAQ },
    // { path: '/guide/no-reaction', name: 'NoReaction', component: NoReaction },
    // { path: '/guide/cannot-find-device', name: 'CannotFindDevice', component: CannotFindDevice },
    // { path: '/guide/connection-failed-firmware-version', name: 'ConnectionFailedFirmwareVersion', component: ConnectionFailedFirmwareVersion }
    {
      path: '/policy/privacy',
      name: 'Privacy',
      component: () => getComponentByLang('Privacy'),  // 动态加载 Privacy 组件
    },
    {
      path: '/policy/dont-sell',
      name: 'DontSell',
      component: () => getComponentByLang('DontSell'),
    },
    {
      path: '/policy/privacy-summary',
      name: 'PrivacySummary',
      component: () => getComponentByLang('PrivacySummary'),  // 动态加载 Privacy 组件
    },
    {
      path: '/policy/user-agreement',
      name: 'UserAgreement',
      component: () => getComponentByLang('UserAgreement'),  // 动态加载 UserAgreement 组件
    },
    {
      path: '/policy/youth-protection',
      name: 'YouthProtection',
      component: () => getComponentByLang('YouthProtection'),  // 动态加载 UserAgreement 组件
    },
    {
      path: '/policy/third-party-sharing',
      name: 'ThirdPartySharingList',
      component: () => getComponentByLang('ThirdPartySharingList'),
    },
    {
      path: '/policy/CMCC-terms',
      name: 'CMCCTerms',
      component: () => getComponentByLang('CMCCTerms'),
    },
    {
      path: '/policy/delete-account',
      name: 'DeleteAccount',
      component: () => getComponentByLang('DeleteAccount'),
    },
    {
      path: '/support/no-device',
      name: 'NoDevice',
      component: () => getComponentByLang('NoDevice'),
    },
    {
      path: '/docs/product-instructions',
      name: 'ProductInstructions',
      component: () => getComponentByLang('ProductInstructions'),
    },
    {
      path: '/docs/maintenance-instructions',
      name: 'MaintenanceInstructions',
      component: () => getComponentByLang('MaintenanceInstructions'),
    },
    {
      path: '/guide/FAQ',
      name: 'FAQ',
      component: () => getComponentByLang('FAQ'),
    },
    {
      path: '/guide/no-reaction',
      name: 'NoReaction',
      component: () => getComponentByLang('NoReaction'),
    },
    {
      path: '/guide/cannot-find-device',
      name: 'CannotFindDevice',
      component: () => getComponentByLang('CannotFindDevice'),
    },
    {
      path: '/guide/connection-failed-firmware-version',
      name: 'ConnectionFailedFirmwareVersion',
      component: () => getComponentByLang('ConnectionFailedFirmwareVersion'),
    },
  ]
})

// 动态修改页面标题
router.beforeEach((to, from, next) => {
  const currentLang = getCurrentLanguage();
  const routeName = to.name;
  
  // 根据路由名称和当前语言获取对应的标题
  let title = 'One2Sleep';
  if (routeName && pageTitles[routeName]) {
    title = pageTitles[routeName][currentLang] || pageTitles[routeName]['en'] || pageTitles[routeName]['zh-CN'] || 'One2Sleep';
  }
  
  document.title = title;
  next();
});

export default router



// WEBPACK FOOTER //
// ./src/router/index.js